module.exports = __webpack_public_path__ + "static/img/notext-startripgroup.1893512.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/services/notext-startripgroup.png
// module id = NAvO
// module chunks = 1